module.exports = __webpack_public_path__ + "assets/cbcb0c9c371e4baddbbab0ee4144cf37.mp3";